var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gql } from 'graphql-request';
import { AldrinApiClient } from './aldrinClient';
import { poolResponseToModel } from './utils';
/**
 * Aldrin's backed API client
 */
var AldrinApiPoolsClient = /** @class */ (function (_super) {
    __extends(AldrinApiPoolsClient, _super);
    function AldrinApiPoolsClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get TVL for AMM pools
     * @returns last value in USD
     */
    AldrinApiPoolsClient.prototype.getTotalVolumeLocked = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timestampFrom, timestampTo, query, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        timestampFrom = Math.floor(Date.now() / 1000 - 60 * 60);
                        timestampTo = Math.floor(Date.now() / 1000);
                        query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    {\n      getTotalVolumeLockedHistory(\n        timezone: \"UTC\", \n        timestampFrom: ", ", \n        timestampTo: ", "\n      ) {\n        volumes {\n          vol\n          date\n        }\n      }\n    }\n    "], ["\n    {\n      getTotalVolumeLockedHistory(\n        timezone: \"UTC\", \n        timestampFrom: ", ", \n        timestampTo: ", "\n      ) {\n        volumes {\n          vol\n          date\n        }\n      }\n    }\n    "])), timestampFrom, timestampTo);
                        return [4 /*yield*/, this.gqlClient.request(query)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.getTotalVolumeLockedHistory.volumes[0].vol];
                }
            });
        });
    };
    /**
     * @returns Extended information about existing pools
     */
    AldrinApiPoolsClient.prototype.getPoolsInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, tokens, getPricesQuery, pricesResponse, prices, parsed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      query getPoolsInfoQuery {\n        getPoolsInfo {\n          name\n          parsedName\n          swapToken\n          poolTokenMint\n          tokenA\n          tokenB\n          poolTokenAccountA\n          poolTokenAccountB\n          lpTokenFreezeVaultBalance\n          tvl {\n            tokenA\n            tokenB\n          }\n          apy24h\n          supply\n          farming {\n            farmingState\n            farmingTokenVault\n            farmingTokenMint\n            farmingTokenMintDecimals\n            farmingSnapshots\n            tokensUnlocked\n            tokensTotal\n            tokensPerPeriod\n            periodLength\n            vestingPeriod\n            currentTime\n          }\n        }\n      }\n    "], ["\n      query getPoolsInfoQuery {\n        getPoolsInfo {\n          name\n          parsedName\n          swapToken\n          poolTokenMint\n          tokenA\n          tokenB\n          poolTokenAccountA\n          poolTokenAccountB\n          lpTokenFreezeVaultBalance\n          tvl {\n            tokenA\n            tokenB\n          }\n          apy24h\n          supply\n          farming {\n            farmingState\n            farmingTokenVault\n            farmingTokenMint\n            farmingTokenMintDecimals\n            farmingSnapshots\n            tokensUnlocked\n            tokensTotal\n            tokensPerPeriod\n            periodLength\n            vestingPeriod\n            currentTime\n          }\n        }\n      }\n    "])));
                        return [4 /*yield*/, this.gqlClient.request(query)];
                    case 1:
                        response = _a.sent();
                        tokens = new Set();
                        response.getPoolsInfo.forEach(function (p) {
                            var _a = p.parsedName.split('_'), base = _a[0], quote = _a[1];
                            tokens.add(base);
                            tokens.add(quote);
                        });
                        getPricesQuery = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      query getDexTokensPrices($symbols: [String!]) {\n        getDexTokensPrices(symbols: $symbols) {\n          symbol\n          price\n        }\n      }            \n    "], ["\n      query getDexTokensPrices($symbols: [String!]) {\n        getDexTokensPrices(symbols: $symbols) {\n          symbol\n          price\n        }\n      }            \n    "])));
                        return [4 /*yield*/, this.gqlClient.request(getPricesQuery, { symbols: Array.from(tokens.values()) })];
                    case 2:
                        pricesResponse = _a.sent();
                        prices = new Map();
                        pricesResponse.getDexTokensPrices.forEach(function (v) { return prices.set(v.symbol, v.price); });
                        parsed = response.getPoolsInfo.map(function (p) { return poolResponseToModel(p, prices); });
                        return [2 /*return*/, parsed];
                }
            });
        });
    };
    return AldrinApiPoolsClient;
}(AldrinApiClient));
export { AldrinApiPoolsClient };
var templateObject_1, templateObject_2, templateObject_3;
